import { render, staticRenderFns } from "./ClassAnalyticsLessonsList.vue?vue&type=template&id=94b06e10&"
import script from "./ClassAnalyticsLessonsList.vue?vue&type=script&lang=js&"
export * from "./ClassAnalyticsLessonsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports